export const countryList = [
    { code: 'AD', name: 'Andorra', label: 'AD - Andorra' },
    { code: 'AE', name: 'Utd.Arab Emir.', label: 'AE - Utd.Arab Emir.' },
    { code: 'AF', name: 'Afghanistan', label: 'AF - Afghanistan' },
    { code: 'AG', name: 'Antigua/Barbuda', label: 'AG - Antigua/Barbuda' },
    { code: 'AI', name: 'Anguilla', label: 'AI - Anguilla' },
    { code: 'AL', name: 'Albania', label: 'AL - Albania' },
    { code: 'AM', name: 'Armenia', label: 'AM - Armenia' },
    { code: 'AN', name: 'Dutch Antilles', label: 'AN - Dutch Antilles' },
    { code: 'AO', name: 'Angola', label: 'AO - Angola' },
    { code: 'AQ', name: 'Antarctica', label: 'AQ - Antarctica' },
    { code: 'AR', name: 'Argentina', label: 'AR - Argentina' },
    { code: 'AS', name: 'Samoa, America', label: 'AS - Samoa, America' },
    { code: 'AT', name: 'Austria', label: 'AT - Austria' },
    { code: 'AU', name: 'Australia', label: 'AU - Australia' },
    { code: 'AW', name: 'Aruba', label: 'AW - Aruba' },
    { code: 'AZ', name: 'Azerbaijan', label: 'AZ - Azerbaijan' },
    { code: 'BA', name: 'Bosnia-Herz.', label: 'BA - Bosnia-Herz.' },
    { code: 'BB', name: 'Barbados', label: 'BB - Barbados' },
    { code: 'BD', name: 'Bangladesh', label: 'BD - Bangladesh' },
    { code: 'BE', name: 'Belgium', label: 'BE - Belgium' },
    { code: 'BF', name: 'Burkina Faso', label: 'BF - Burkina Faso' },
    { code: 'BG', name: 'Bulgaria', label: 'BG - Bulgaria' },
    { code: 'BH', name: 'Bahrain', label: 'BH - Bahrain' },
    { code: 'BI', name: 'Burundi', label: 'BI - Burundi' },
    { code: 'BJ', name: 'Benin', label: 'BJ - Benin' },
    { code: 'BM', name: 'Bermuda', label: 'BM - Bermuda' },
    { code: 'BN', name: 'Brunei Daruss.', label: 'BN - Brunei Daruss.' },
    { code: 'BO', name: 'Bolivia', label: 'BO - Bolivia' },
    { code: 'BR', name: 'Brazil', label: 'BR - Brazil' },
    { code: 'BS', name: 'Bahamas', label: 'BS - Bahamas' },
    { code: 'BT', name: 'Bhutan', label: 'BT - Bhutan' },
    { code: 'BV', name: 'Bouvet Islands', label: 'BV - Bouvet Islands' },
    { code: 'BW', name: 'Botswana', label: 'BW - Botswana' },
    { code: 'BY', name: 'Belarus', label: 'BY - Belarus' },
    { code: 'BZ', name: 'Belize', label: 'BZ - Belize' },
    { code: 'CA', name: 'Canada', label: 'CA - Canada' },
    { code: 'CC', name: 'Coconut Islands', label: 'CC - Coconut Islands' },
    { code: 'CD', name: 'Dem. Rep. Congo', label: 'CD - Dem. Rep. Congo' },
    { code: 'CF', name: 'CAR', label: 'CF - CAR' },
    { code: 'CG', name: 'Rep. Congo', label: 'CG - Rep. Congo' },
    { code: 'CH', name: 'Switzerland', label: 'CH - Switzerland' },
    { code: 'CI', name: "Cote d'Ivoire", label: "CI - Cote d'Ivoire" },
    { code: 'CK', name: 'Cook Islands', label: 'CK - Cook Islands' },
    { code: 'CL', name: 'Chile', label: 'CL - Chile' },
    { code: 'CM', name: 'Cameroon', label: 'CM - Cameroon' },
    { code: 'CN', name: 'China', label: 'CN - China' },
    { code: 'CO', name: 'Colombia', label: 'CO - Colombia' },
    { code: 'CR', name: 'Costa Rica', label: 'CR - Costa Rica' },
    { code: 'CS', name: 'Serbia/Monten.', label: 'CS - Serbia/Monten.' },
    { code: 'CU', name: 'Cuba', label: 'CU - Cuba' },
    { code: 'CV', name: 'Cape Verde', label: 'CV - Cape Verde' },
    { code: 'CX', name: 'Christmas Islnd', label: 'CX - Christmas Islnd' },
    { code: 'CY', name: 'Cyprus', label: 'CY - Cyprus' },
    { code: 'CZ', name: 'Czech Republic', label: 'CZ - Czech Republic' },
    { code: 'DE', name: 'Germany', label: 'DE - Germany' },
    { code: 'DJ', name: 'Djibouti', label: 'DJ - Djibouti' },
    { code: 'DK', name: 'Denmark', label: 'DK - Denmark' },
    { code: 'DM', name: 'Dominica', label: 'DM - Dominica' },
    { code: 'DO', name: 'Dominican Rep.', label: 'DO - Dominican Rep.' },
    { code: 'DZ', name: 'Algeria', label: 'DZ - Algeria' },
    { code: 'EC', name: 'Ecuador', label: 'EC - Ecuador' },
    { code: 'EE', name: 'Estonia', label: 'EE - Estonia' },
    { code: 'EG', name: 'Egypt', label: 'EG - Egypt' },
    { code: 'EH', name: 'West Sahara', label: 'EH - West Sahara' },
    { code: 'ER', name: 'Eritrea', label: 'ER - Eritrea' },
    { code: 'ES', name: 'Spain', label: 'ES - Spain' },
    { code: 'ET', name: 'Ethiopia', label: 'ET - Ethiopia' },
    { code: 'FI', name: 'Finland', label: 'FI - Finland' },
    { code: 'FJ', name: 'Fiji', label: 'FJ - Fiji' },
    { code: 'FK', name: 'Falkland Islnds', label: 'FK - Falkland Islnds' },
    { code: 'FM', name: 'Micronesia', label: 'FM - Micronesia' },
    { code: 'FO', name: 'Faroe Islands', label: 'FO - Faroe Islands' },
    { code: 'FR', name: 'France', label: 'FR - France' },
    { code: 'GA', name: 'Gabon', label: 'GA - Gabon' },
    { code: 'GB', name: 'United Kingdom', label: 'GB - United Kingdom' },
    { code: 'GD', name: 'Grenada', label: 'GD - Grenada' },
    { code: 'GE', name: 'Georgia', label: 'GE - Georgia' },
    { code: 'GF', name: 'French Guiana', label: 'GF - French Guiana' },
    { code: 'GH', name: 'Ghana', label: 'GH - Ghana' },
    { code: 'GI', name: 'Gibraltar', label: 'GI - Gibraltar' },
    { code: 'GL', name: 'Greenland', label: 'GL - Greenland' },
    { code: 'GM', name: 'Gambia', label: 'GM - Gambia' },
    { code: 'GN', name: 'Guinea', label: 'GN - Guinea' },
    { code: 'GP', name: 'Guadeloupe', label: 'GP - Guadeloupe' },
    { code: 'GQ', name: 'Equat. Guinea', label: 'GQ - Equat. Guinea' },
    { code: 'GR', name: 'Greece', label: 'GR - Greece' },
    { code: 'GS', name: 'S. Sandwich Is.', label: 'GS - S. Sandwich Is.' },
    { code: 'GT', name: 'Guatemala', label: 'GT - Guatemala' },
    { code: 'GU', name: 'Guam', label: 'GU - Guam' },
    { code: 'GW', name: 'Guinea-Bissau', label: 'GW - Guinea-Bissau' },
    { code: 'GY', name: 'Guyana', label: 'GY - Guyana' },
    { code: 'HK', name: 'Hong Kong', label: 'HK - Hong Kong' },
    { code: 'HM', name: 'Heard/McDon.Isl', label: 'HM - Heard/McDon.Isl' },
    { code: 'HN', name: 'Honduras', label: 'HN - Honduras' },
    { code: 'HR', name: 'Croatia', label: 'HR - Croatia' },
    { code: 'HT', name: 'Haiti', label: 'HT - Haiti' },
    { code: 'HU', name: 'Hungary', label: 'HU - Hungary' },
    { code: 'ID', name: 'Indonesia', label: 'ID - Indonesia' },
    { code: 'IE', name: 'Ireland', label: 'IE - Ireland' },
    { code: 'IL', name: 'Israel', label: 'IL - Israel' },
    { code: 'IN', name: 'India', label: 'IN - India' },
    { code: 'IO', name: 'Brit.Ind.Oc.Ter', label: 'IO - Brit.Ind.Oc.Ter' },
    { code: 'IQ', name: 'Iraq', label: 'IQ - Iraq' },
    { code: 'IR', name: 'Iran', label: 'IR - Iran' },
    { code: 'IS', name: 'Iceland', label: 'IS - Iceland' },
    { code: 'IT', name: 'Italy', label: 'IT - Italy' },
    { code: 'IV', name: 'Ivory Coast', label: 'IV - Ivory Coast' },
    { code: 'JM', name: 'Jamaica', label: 'JM - Jamaica' },
    { code: 'JO', name: 'Jordan', label: 'JO - Jordan' },
    { code: 'JP', name: 'Japan', label: 'JP - Japan' },
    { code: 'KE', name: 'Kenya', label: 'KE - Kenya' },
    { code: 'KG', name: 'Kyrgyzstan', label: 'KG - Kyrgyzstan' },
    { code: 'KH', name: 'Cambodia', label: 'KH - Cambodia' },
    { code: 'KI', name: 'Kiribati', label: 'KI - Kiribati' },
    { code: 'KM', name: 'Comoros', label: 'KM - Comoros' },
    { code: 'KN', name: 'St Kitts&Nevis', label: 'KN - St Kitts&Nevis' },
    { code: 'KO', name: 'KOSOVO', label: 'KO - KOSOVO' },
    { code: 'KP', name: 'North Korea', label: 'KP - North Korea' },
    { code: 'KR', name: 'South Korea', label: 'KR - South Korea' },
    { code: 'KW', name: 'Kuwait', label: 'KW - Kuwait' },
    { code: 'KY', name: 'Cayman Islands', label: 'KY - Cayman Islands' },
    { code: 'KZ', name: 'Kazakhstan', label: 'KZ - Kazakhstan' },
    { code: 'LA', name: 'Laos', label: 'LA - Laos' },
    { code: 'LB', name: 'Lebanon', label: 'LB - Lebanon' },
    { code: 'LC', name: 'St. Lucia', label: 'LC - St. Lucia' },
    { code: 'LI', name: 'Liechtenstein', label: 'LI - Liechtenstein' },
    { code: 'LK', name: 'Sri Lanka', label: 'LK - Sri Lanka' },
    { code: 'LR', name: 'Liberia', label: 'LR - Liberia' },
    { code: 'LS', name: 'Lesotho', label: 'LS - Lesotho' },
    { code: 'LT', name: 'Lithuania', label: 'LT - Lithuania' },
    { code: 'LU', name: 'Luxembourg', label: 'LU - Luxembourg' },
    { code: 'LV', name: 'Latvia', label: 'LV - Latvia' },
    { code: 'LY', name: 'Libya', label: 'LY - Libya' },
    { code: 'MA', name: 'Morocco', label: 'MA - Morocco' },
    { code: 'MC', name: 'Monaco', label: 'MC - Monaco' },
    { code: 'MD', name: 'Moldova', label: 'MD - Moldova' },
    { code: 'MG', name: 'Madagascar', label: 'MG - Madagascar' },
    { code: 'MH', name: 'Marshall Is.', label: 'MH - Marshall Is.' },
    { code: 'MK', name: 'Macedonia', label: 'MK - Macedonia' },
    { code: 'ML', name: 'Mali', label: 'ML - Mali' },
    { code: 'MM', name: 'Burma', label: 'MM - Burma' },
    { code: 'MN', name: 'Mongolia', label: 'MN - Mongolia' },
    { code: 'MO', name: 'Macau', label: 'MO - Macau' },
    { code: 'MP', name: 'N.Mariana Islnd', label: 'MP - N.Mariana Islnd' },
    { code: 'MQ', name: 'Martinique', label: 'MQ - Martinique' },
    { code: 'MR', name: 'Mauritania', label: 'MR - Mauritania' },
    { code: 'MS', name: 'Montserrat', label: 'MS - Montserrat' },
    { code: 'MT', name: 'Malta', label: 'MT - Malta' },
    { code: 'MU', name: 'Mauritius', label: 'MU - Mauritius' },
    { code: 'MV', name: 'Maldives', label: 'MV - Maldives' },
    { code: 'MW', name: 'Malawi', label: 'MW - Malawi' },
    { code: 'MX', name: 'Mexico', label: 'MX - Mexico' },
    { code: 'MY', name: 'Malaysia', label: 'MY - Malaysia' },
    { code: 'MZ', name: 'Mozambique', label: 'MZ - Mozambique' },
    { code: 'NA', name: 'Namibia', label: 'NA - Namibia' },
    { code: 'NC', name: 'New Caledonia', label: 'NC - New Caledonia' },
    { code: 'NE', name: 'Niger', label: 'NE - Niger' },
    { code: 'NF', name: 'Norfolk Islands', label: 'NF - Norfolk Islands' },
    { code: 'NG', name: 'Nigeria', label: 'NG - Nigeria' },
    { code: 'NI', name: 'Nicaragua', label: 'NI - Nicaragua' },
    { code: 'NL', name: 'Netherlands', label: 'NL - Netherlands' },
    { code: 'NO', name: 'Norway', label: 'NO - Norway' },
    { code: 'NP', name: 'Nepal', label: 'NP - Nepal' },
    { code: 'NR', name: 'Nauru', label: 'NR - Nauru' },
    { code: 'NU', name: 'Niue', label: 'NU - Niue' },
    { code: 'NZ', name: 'New Zealand', label: 'NZ - New Zealand' },
    { code: 'OM', name: 'Oman', label: 'OM - Oman' },
    { code: 'PA', name: 'Panama', label: 'PA - Panama' },
    { code: 'PE', name: 'Peru', label: 'PE - Peru' },
    { code: 'PF', name: 'Frenc.Polynesia', label: 'PF - Frenc.Polynesia' },
    { code: 'PG', name: 'Pap. New Guinea', label: 'PG - Pap. New Guinea' },
    { code: 'PH', name: 'Philippines', label: 'PH - Philippines' },
    { code: 'PK', name: 'Pakistan', label: 'PK - Pakistan' },
    { code: 'PL', name: 'Poland', label: 'PL - Poland' },
    { code: 'PM', name: 'St.Pier,Miquel.', label: 'PM - St.Pier,Miquel.' },
    { code: 'PN', name: 'Pitcairn Is.', label: 'PN - Pitcairn Is.' },
    { code: 'PR', name: 'Puerto Rico', label: 'PR - Puerto Rico' },
    { code: 'PS', name: 'Palestine', label: 'PS - Palestine' },
    { code: 'PT', name: 'Portugal', label: 'PT - Portugal' },
    { code: 'PW', name: 'Palau', label: 'PW - Palau' },
    { code: 'PY', name: 'Paraguay', label: 'PY - Paraguay' },
    { code: 'QA', name: 'Qatar', label: 'QA - Qatar' },
    { code: 'RE', name: 'Reunion', label: 'RE - Reunion' },
    { code: 'RO', name: 'Romania', label: 'RO - Romania' },
    { code: 'RS', name: 'Serbia', label: 'RS - Serbia' },
    { code: 'RU', name: 'Russian Fed.', label: 'RU - Russian Fed.' },
    { code: 'RW', name: 'Rwanda', label: 'RW - Rwanda' },
    { code: 'SA', name: 'Saudi Arabia', label: 'SA - Saudi Arabia' },
    { code: 'SB', name: 'Solomon Islands', label: 'SB - Solomon Islands' },
    { code: 'SC', name: 'Seychelles', label: 'SC - Seychelles' },
    { code: 'SD', name: 'Sudan', label: 'SD - Sudan' },
    { code: 'SE', name: 'Sweden', label: 'SE - Sweden' },
    { code: 'SG', name: 'Singapore', label: 'SG - Singapore' },
    { code: 'SH', name: 'St. Helena', label: 'SH - St. Helena' },
    { code: 'SI', name: 'Slovenia', label: 'SI - Slovenia' },
    { code: 'SJ', name: 'Svalbard', label: 'SJ - Svalbard' },
    { code: 'SK', name: 'Slovakia', label: 'SK - Slovakia' },
    { code: 'SL', name: 'Sierra Leone', label: 'SL - Sierra Leone' },
    { code: 'SM', name: 'San Marino', label: 'SM - San Marino' },
    { code: 'SN', name: 'Senegal', label: 'SN - Senegal' },
    { code: 'SO', name: 'Somalia', label: 'SO - Somalia' },
    { code: 'SR', name: 'Suriname', label: 'SR - Suriname' },
    { code: 'ST', name: 'S.Tome,Principe', label: 'ST - S.Tome,Principe' },
    { code: 'SV', name: 'El Salvador', label: 'SV - El Salvador' },
    { code: 'SY', name: 'Syria', label: 'SY - Syria' },
    { code: 'SZ', name: 'Swaziland', label: 'SZ - Swaziland' },
    { code: 'TC', name: 'Turks/Caicos Is', label: 'TC - Turks/Caicos Is' },
    { code: 'TD', name: 'Chad', label: 'TD - Chad' },
    { code: 'TF', name: 'French S.Territ', label: 'TF - French S.Territ' },
    { code: 'TG', name: 'Togo', label: 'TG - Togo' },
    { code: 'TH', name: 'Thailand', label: 'TH - Thailand' },
    { code: 'TJ', name: 'Tajikistan', label: 'TJ - Tajikistan' },
    { code: 'TK', name: 'Tokelau Islands', label: 'TK - Tokelau Islands' },
    { code: 'TL', name: 'East Timor', label: 'TL - East Timor' },
    { code: 'TM', name: 'Turkmenistan', label: 'TM - Turkmenistan' },
    { code: 'TN', name: 'Tunisia', label: 'TN - Tunisia' },
    { code: 'TO', name: 'Tonga', label: 'TO - Tonga' },
    { code: 'TP', name: 'East Timor', label: 'TP - East Timor' },
    { code: 'TR', name: 'Turkey', label: 'TR - Turkey' },
    { code: 'TT', name: 'Trinidad,Tobago', label: 'TT - Trinidad,Tobago' },
    { code: 'TV', name: 'Tuvalu', label: 'TV - Tuvalu' },
    { code: 'TW', name: 'Taiwan', label: 'TW - Taiwan' },
    { code: 'TZ', name: 'Tanzania', label: 'TZ - Tanzania' },
    { code: 'UA', name: 'Ukraine', label: 'UA - Ukraine' },
    { code: 'UG', name: 'Uganda', label: 'UG - Uganda' },
    { code: 'UM', name: 'Minor Outl. Is.', label: 'UM - Minor Outl. Is.' },
    { code: 'US', name: 'USA', label: 'US - USA' },
    { code: 'UY', name: 'Uruguay', label: 'UY - Uruguay' },
    { code: 'UZ', name: 'Uzbekistan', label: 'UZ - Uzbekistan' },
    { code: 'VA', name: 'Vatican City', label: 'VA - Vatican City' },
    { code: 'VC', name: 'St. Vincent', label: 'VC - St. Vincent' },
    { code: 'VE', name: 'Venezuela', label: 'VE - Venezuela' },
    { code: 'VG', name: 'Brit.Virgin Is.', label: 'VG - Brit.Virgin Is.' },
    { code: 'VI', name: 'Amer.Virgin Is.', label: 'VI - Amer.Virgin Is.' },
    { code: 'VN', name: 'Vietnam', label: 'VN - Vietnam' },
    { code: 'VU', name: 'Vanuatu', label: 'VU - Vanuatu' },
    { code: 'WF', name: 'Wallis,Futuna', label: 'WF - Wallis,Futuna' },
    { code: 'WS', name: 'Samoa', label: 'WS - Samoa' },
    { code: 'YE', name: 'Yemen', label: 'YE - Yemen' },
    { code: 'YT', name: 'Mayotte', label: 'YT - Mayotte' },
    { code: 'YU', name: 'N/A', label: 'YU - N/A' },
    { code: 'ZA', name: 'South Africa', label: 'ZA - South Africa' },
    { code: 'ZM', name: 'Zambia', label: 'ZM - Zambia' },
    { code: 'ZW', name: 'Zimbabwe', label: 'ZW - Zimbabwe' },
];
